import { Box, Select, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react'
import * as api from '../services/api'
import { useDispatch } from 'react-redux';
import { menuActive } from '../../store/menuSlice';
import Loader from '../../components/Loader';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

function AssessmentResult() { 
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});  
  const [year, setYear] = useState("null")
  const [yearOption, setYearOption] = useState([])
  const [department, setDepartment] = useState("null")
  const [departmentOption, setDepartmentOption] = useState([])

  useEffect(() => {
    dispatch(menuActive('ภาพรวมแบบประเมิน'));
    fetchOption();
    fetchResult("null","null");
  }, []);

  const fetchResult = async (updatedYear,updatedDepartment) => {
    
    setLoading(true);
    const res = await api.getAssessmentResult(updatedYear,updatedDepartment);
    setLoading(false);
      if (res) {
        if (res['data']['code'] === 200) {
          const detail = res['data']['data']['summary'];
          setData(detail);
        } else {
          //alert(res['data']['message']);
        }
        } else {
          alert("ไม่ตอบสนอง");
        }
    
  };

  const fetchOption = async () => {
    const year_res = await api.getAssessmentResultYear();
    if (year_res) {
      if (year_res['data']['code'] === 200) {
        const detail = year_res['data']['data'];
        const yearOptions = detail.map((item) => ({ key: item.value, value: item.label }));
        setYearOption(yearOptions);
      } else {
        alert(year_res['data']['message']);
      }
    } else {
      alert("ไม่ตอบสนอง");
    }

    const department_res = await api.getAssessmentResultDepartment();
    if (department_res) {
      if (department_res['data']['code'] === 200) {
        const detail = department_res['data']['data'];
        const departmentOptions = detail.map((item) => ({ key: item.department_code, value: item.department_name }));
        setDepartmentOption(departmentOptions);
      } else {
        alert(department_res['data']['message']);
      }
    } else {
      alert("ไม่ตอบสนอง");
    }
  };

  const handleFilterGroup = async (e) => {
    const { value, name } = e.target;
  
    let updatedYear = year;
    let updatedDepartment = department;
  
    if (name === 'year') {
      updatedYear = value;
    } else if (name === 'department') {
      updatedDepartment = value;
    }
    await setYear(updatedYear);
    await setDepartment(updatedDepartment);
    fetchResult(updatedYear, updatedDepartment);
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 24,
    borderRadius: 15,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[300],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: '#478F96',
    },
  }));


  return (
    <>
    <Loader loading={loading} />

    <Box sx={{ display: 'grid', gridGap: '10px' }}>   
        <Box sx={{
          fontWeight: 600,
          color: "#478F96",
          "@media (max-width: 800px)": {
            textAlign: "center",
          },
          }}>ภาพรวมแบบประเมิน</Box>
        <Box sx={{fontSize: 14}}>ตรวจสอบภาพรวมแบบประเมินของกำลังพล</Box>

    </Box>

    <Box
          sx={{
          border: "1px solid #AEB4DD",
          borderRadius: "5px",
          padding: "20px",
          marginTop: "20px",
          }}
    >

    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '20px' }}>
      <Box>
        <Box sx={{ fontSize: 14, fontWeight: 'bold' }}>เลือกปี</Box>
          <Select
            size="small"
            sx={{ ...SelectCss, width: '150px' }}
            value={year || "null"}
            name="year"
            onChange={(e) => { handleFilterGroup(e) }}
          >
            <MenuItem value="null">ทั้งหมด</MenuItem>
            {yearOption.map((i, idx) => (
              <MenuItem key={idx} value={i['key']}>{i['value']}</MenuItem>
            ))}
          </Select>
      </Box>
      
      <Box>
        <Box sx={{ fontSize: 14, fontWeight: 'bold' }}>เลือกสังกัด</Box>
          <Select
            size="small"
            sx={{ ...SelectCss , width: '150px'}}
            value={department || "null"}
            name="department"
            onChange={(e) => { handleFilterGroup(e) }}
            displayEmpty
          >
            <MenuItem value="null">ทั้งหมด</MenuItem>
            {departmentOption.map((i, idx) => (
              <MenuItem key={idx} value={i['key']}>{i['value']}</MenuItem>
            ))}
          </Select>
      </Box>
    </Box>

    {/* smaller box */}
    <Box
          sx={{
          border: "1px solid #478F96",
          borderRadius: "5px",
          padding: "20px",
          marginTop: "20px",
          }}
    > 
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
        {/* 1 */}
        <Box sx={{ flex: '0 0 22%' }}>
          <Box sx={{ fontSize: 14, fontWeight: 'bold', marginBottom: "10px" }}>จำนวนกำลังพล สป. ทั้งหมด</Box>
          <Box sx={{ fontSize: 15 }}>{data.number_of_people} คน</Box>
        </Box>
        {/* 2 */}
        <Box sx={{ flex: '0 0 24%' }}>
          <Box sx={{ fontSize: 14, fontWeight: 'bold', marginBottom: "10px" }}>เข้าร่วมการประเมิน/ทั้งหมด</Box>
          <Box sx={{ fontSize: 15 }}>{data.total_evaluation_record}/{data.number_of_people} คน</Box>
        </Box>
        {/* 3 */}
        <Box sx={{ flex: '0 0 54%', boxSizing: 'border-box', padding: '0 10px' }}>
          {participantBar(data.total_evaluation_record, data.number_of_people,BorderLinearProgress)}
        </Box>
      </Box>
    </Box>

    {/* Loop */}
    {data.evaluation_record && data.evaluation_record.map((item, index) => (
      <Box
        key={index}
        sx={{
          borderRadius: "5px",
          padding: "20px",
          marginTop: "20px",
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
          {/* Image */}
          {/* <Box sx={{ flex: '0 0 20%', marginRight: '20px' }}>
            <img 
              src={item.evaluation_image} 
              alt={item.evaluation_name} 
              style={{ width: '100%', borderRadius: '5px' }} 
            />
          </Box>
          <Box sx={{ flex: '0 0 80%' }}> */}
          <Box sx={{ flex: '0 0 100%' }}>
            {/* Evaluation_name */}
            <Box sx={{
              fontWeight: 600,
              color: "#478F96",
              marginBottom: "10px",
              "@media (max-width: 800px)": {
                textAlign: "center",
              },
              }}>{item.evaluation_name}</Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            {/* Participated/Total */}
              <Box sx={{ flex: '0 0 30%' }}>
                <Box sx={{ fontSize: 14, fontWeight: 'bold', marginBottom: "10px" }}>เข้าร่วมการประเมิน/ทั้งหมด</Box>
                <Box sx={{ fontSize: 15 }}>{item.total_evaluation_record}/{item.number_of_people} คน</Box>
              </Box>
            {/* Progress Bar */}
              <Box sx={{ flex: '0 0 67%', boxSizing: 'border-box', padding: '0 10px' }}>
                {participantBar(item.total_evaluation_record, item.number_of_people, BorderLinearProgress)}
              </Box>
            </Box>
            
          </Box>
          
        </Box>
      </Box>
    ))}

  </Box>
  </>
  );
}

export default AssessmentResult;

const SelectCss = {
  backgroundColor: '#C8EBEB',
  border: 'none',
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
}

function participantBar(total_evaluation_record, number_of_people, BorderLinearProgress) {
  const participantPercentage = ((total_evaluation_record / number_of_people) * 100).toFixed(2);
  const nonParticipantPercentage = (100 - (total_evaluation_record / number_of_people) * 100).toFixed(2);

  return (
    <>
        <Box sx={{ fontSize: 14, fontWeight: 'bold', marginBottom: "10px" }}>ร้อยละ</Box>
          {/* Progress bar container */}
          <Box sx={{ position: 'relative', width: '100%' }}>
            {/* Percentage label: total_evaluation_record */}
            {participantPercentage >= 10 && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '5px', 
                  left: `${(total_evaluation_record / number_of_people) * 90}%`, 
                  transform: 'translateX(-50%)', 
                  fontSize: 12,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  color: 'white',
                  zIndex: 10,
                  display: { xs: 'none', sm: 'block' }
                }}
              >
                {participantPercentage}%
              </Box>
            )}
            {/* Percentage label: not participated */}
            {nonParticipantPercentage >= 10 && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '5px', 
                  right: '0px', 
                  transform: 'translateX(-50%)', 
                  fontSize: 12,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  color: 'white',
                  zIndex: 10,
                  display: { xs: 'none', sm: 'block' }
                }}
              >
                {nonParticipantPercentage}%
              </Box>
            )}
            <BorderLinearProgress
              variant="determinate"
              value={participantPercentage}
              sx={{ width: '100%' }}
            />
          </Box>    
    </>
  );

}
